import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TabsComponent } from './tabs/tabs.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ReferanceComponent } from './referance/referance.component';
import { ReviewFilesComponent } from './review-files/review-files.component';
import { InitiateDownloadComponent } from './initiate-download/initiate-download.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { FlagDragNDropDirective } from './directive/flag-drag-ndrop.directive';
import { FileSizePipe } from './pipes/file-size.pipe';
import { NgxSpinnerModule} from 'ngx-spinner';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ReCaptchaComponent } from './re-captcha/re-captcha.component';
import { FooterComponent } from './footer/footer.component';
import { EmailAuthComponent } from './email-auth/email-auth.component';
import { HeaderComponent } from './header/header.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { ApimInterceptor } from './shared/apim.interceptor';
import { EmptyComponent } from './empty/empty.component';
import { FileStatusComponent } from './file-status/file-status.component';
import { InstructionsComponent } from './instructions/instructions.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { RoutingComponent } from './routing/routing.component';
import { MetaBarComponent } from './meta-bar/meta-bar.component';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    TabsComponent,
    FileUploadComponent,
    ReferanceComponent,
    ReviewFilesComponent,
    InitiateDownloadComponent,
    ConfirmationComponent,
    FlagDragNDropDirective,
    FileSizePipe,
    ReCaptchaComponent,
    FooterComponent,
    EmailAuthComponent,
    HeaderComponent,
    EmptyComponent,
    FileStatusComponent,
    InstructionsComponent,
    ProgressBarComponent,
    RoutingComponent,
    MetaBarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgbTooltipModule,
    RecaptchaModule 
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    FileSizePipe,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApimInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
